import { ProtectedRoute } from "@/components/ProtectedRoute";
import { createFileRoute } from "@tanstack/react-router";
import { LessonTrashPage } from "../../../../pages/lesson/LessonTrashPage";

export const Route = createFileRoute("/admin/lesson/$lessonId/trash")({
  component: ProtectedLessonTrashPage,
});

function ProtectedLessonTrashPage() {
  return (
    <ProtectedRoute>
      <LessonTrashPage />
    </ProtectedRoute>
  );
}
